export default {
    da: {
        longDateTimeFormat: 'dddd [d.] LL [kl.] LT',
        cinema: 'Biograf',
        circus: 'Cirkus',
        age: 'Censur',
        duration: 'Varighed',
        durationTo: 'til ca.'
    },

    en: {
        longDateTimeFormat: 'dddd LL [at] LT',
        cinema: 'Cinema',
        circus: 'Circus',
        age: 'Censoring',
        duration: 'Duration',
        durationTo: 'to approx.'
    }
}